import * as z from 'zod';

export const CreatePolicyRequest = z.object({
  policy: z
    .object({
      _id: z
        .string()
        .describe('Policy ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the policy is updated.\n\nTo prevent conflicting changes, the current revision must be used when updating a policy.'
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe(
          'Date and time the policy was created in `yyyy-mm-ddThh:mm:sssZ` format.'
        )
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe(
          'Date and time the policy was updated in `yyyy-mm-ddThh:mm:sssZ` format.'
        )
        .optional()
        .nullable(),
      name: z
        .string()
        .describe(
          'Policy name that is visible in the dashboard and checkout form.\n\nMin: 1 character  <br/>\nMax: 40 characters'
        )
        .min(1)
        .max(40),
      body: z
        .string()
        .describe(
          'Policy body. Usually contains various terms and conditions.\n\nMin: 1 character\nMax: 50,000 characters\n\n<b>Note:</b> You can format text using various HTML tags such as `<p>`, `<b>`, `<ul>`, etc.'
        )
        .min(1)
        .max(50000),
      eventId: z
        .string()
        .describe('ID of the event to which the policy belongs.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        ),
    })
    .describe('Policy info.'),
});
export const CreatePolicyResponse = z.object({
  _id: z
    .string()
    .describe('Policy ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the policy is updated.\n\nTo prevent conflicting changes, the current revision must be used when updating a policy.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe(
      'Date and time the policy was created in `yyyy-mm-ddThh:mm:sssZ` format.'
    )
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe(
      'Date and time the policy was updated in `yyyy-mm-ddThh:mm:sssZ` format.'
    )
    .optional()
    .nullable(),
  name: z
    .string()
    .describe(
      'Policy name that is visible in the dashboard and checkout form.\n\nMin: 1 character  <br/>\nMax: 40 characters'
    )
    .min(1)
    .max(40)
    .optional(),
  body: z
    .string()
    .describe(
      'Policy body. Usually contains various terms and conditions.\n\nMin: 1 character\nMax: 50,000 characters\n\n<b>Note:</b> You can format text using various HTML tags such as `<p>`, `<b>`, `<ul>`, etc.'
    )
    .min(1)
    .max(50000)
    .optional(),
  eventId: z
    .string()
    .describe('ID of the event to which the policy belongs.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional(),
});
export const UpdatePolicyRequest = z.object({
  _id: z
    .string()
    .describe('Policy ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  policy: z
    .object({
      _id: z
        .string()
        .describe('Policy ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the policy is updated.\n\nTo prevent conflicting changes, the current revision must be used when updating a policy.'
        ),
      _createdDate: z
        .date()
        .describe(
          'Date and time the policy was created in `yyyy-mm-ddThh:mm:sssZ` format.'
        )
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe(
          'Date and time the policy was updated in `yyyy-mm-ddThh:mm:sssZ` format.'
        )
        .optional()
        .nullable(),
      name: z
        .string()
        .describe(
          'Policy name that is visible in the dashboard and checkout form.\n\nMin: 1 character  <br/>\nMax: 40 characters'
        )
        .min(1)
        .max(40),
      body: z
        .string()
        .describe(
          'Policy body. Usually contains various terms and conditions.\n\nMin: 1 character\nMax: 50,000 characters\n\n<b>Note:</b> You can format text using various HTML tags such as `<p>`, `<b>`, `<ul>`, etc.'
        )
        .min(1)
        .max(50000),
      eventId: z
        .string()
        .describe('ID of the event to which the policy belongs.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        ),
    })
    .describe('Policy to update.'),
});
export const UpdatePolicyResponse = z.object({
  _id: z
    .string()
    .describe('Policy ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the policy is updated.\n\nTo prevent conflicting changes, the current revision must be used when updating a policy.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe(
      'Date and time the policy was created in `yyyy-mm-ddThh:mm:sssZ` format.'
    )
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe(
      'Date and time the policy was updated in `yyyy-mm-ddThh:mm:sssZ` format.'
    )
    .optional()
    .nullable(),
  name: z
    .string()
    .describe(
      'Policy name that is visible in the dashboard and checkout form.\n\nMin: 1 character  <br/>\nMax: 40 characters'
    )
    .min(1)
    .max(40)
    .optional(),
  body: z
    .string()
    .describe(
      'Policy body. Usually contains various terms and conditions.\n\nMin: 1 character\nMax: 50,000 characters\n\n<b>Note:</b> You can format text using various HTML tags such as `<p>`, `<b>`, `<ul>`, etc.'
    )
    .min(1)
    .max(50000)
    .optional(),
  eventId: z
    .string()
    .describe('ID of the event to which the policy belongs.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional(),
});
export const DeletePolicyRequest = z.object({
  policyId: z
    .string()
    .describe('ID of the policy to delete.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const DeletePolicyResponse = z.object({});
export const QueryPoliciesRequest = z.object({
  query: z
    .object({
      filter: z
        .object({
          _id: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          eventId: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          revision: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          name: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          body: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          _createdDate: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          _updatedDate: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          $and: z.array(z.any()).optional(),
          $or: z.array(z.any()).optional(),
          $not: z.any().optional(),
        })
        .strict()
        .optional(),
      sort: z
        .array(
          z.object({
            fieldName: z
              .enum([
                '_id',
                'eventId',
                'revision',
                'name',
                'body',
                '_createdDate',
                '_updatedDate',
              ])
              .optional(),
            order: z.enum(['ASC', 'DESC']).optional(),
          })
        )
        .optional(),
    })
    .catchall(z.any())
    .describe(
      'Query options. See [API Query Langauge](https://dev.wix.com/api/rest/getting-started/api-query-language) for more details.'
    ),
});
export const QueryPoliciesResponse = z.object({
  policies: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Policy ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time the policy is updated.\n\nTo prevent conflicting changes, the current revision must be used when updating a policy.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe(
            'Date and time the policy was created in `yyyy-mm-ddThh:mm:sssZ` format.'
          )
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe(
            'Date and time the policy was updated in `yyyy-mm-ddThh:mm:sssZ` format.'
          )
          .optional()
          .nullable(),
        name: z
          .string()
          .describe(
            'Policy name that is visible in the dashboard and checkout form.\n\nMin: 1 character  <br/>\nMax: 40 characters'
          )
          .min(1)
          .max(40)
          .optional(),
        body: z
          .string()
          .describe(
            'Policy body. Usually contains various terms and conditions.\n\nMin: 1 character\nMax: 50,000 characters\n\n<b>Note:</b> You can format text using various HTML tags such as `<p>`, `<b>`, `<ul>`, etc.'
          )
          .min(1)
          .max(50000)
          .optional(),
        eventId: z
          .string()
          .describe('ID of the event to which the policy belongs.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional(),
      })
    )
    .optional(),
  metadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in the response.')
        .optional()
        .nullable(),
      offset: z
        .number()
        .int()
        .describe('Offset that was requested.')
        .optional()
        .nullable(),
      total: z
        .number()
        .int()
        .describe(
          'Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set.'
        )
        .optional()
        .nullable(),
      tooManyToCount: z
        .boolean()
        .describe(
          'Flag that indicates the server failed to calculate the `total` field.'
        )
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe('Cursor pointing to next page in the list of results.')
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to previous page in the list of results.'
            )
            .optional()
            .nullable(),
        })
        .describe(
          'Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used.'
        )
        .optional(),
    })
    .describe('Metadata for the paginated results.')
    .optional(),
});
export const ReorderEventPoliciesRequest = z.object({
  policyId: z
    .string()
    .describe('ID of the policy to reorder.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  eventId: z
    .string()
    .describe('Event ID to which the policy belongs.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z
    .intersection(
      z.object({}),
      z.xor([
        z.object({
          beforePolicyId: z.never().optional(),
          afterPolicyId: z.never().optional(),
        }),
        z.object({
          afterPolicyId: z.never().optional(),
          beforePolicyId: z
            .string()
            .describe('Move the given policy before this specified policy.')
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            ),
        }),
        z.object({
          beforePolicyId: z.never().optional(),
          afterPolicyId: z
            .string()
            .describe('Move the given policy after this specified policy.')
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            ),
        }),
      ])
    )
    .describe('Options for Reorder Event Policies function.')
    .optional(),
});
export const ReorderEventPoliciesResponse = z.object({
  policies: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Policy ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time the policy is updated.\n\nTo prevent conflicting changes, the current revision must be used when updating a policy.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe(
            'Date and time the policy was created in `yyyy-mm-ddThh:mm:sssZ` format.'
          )
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe(
            'Date and time the policy was updated in `yyyy-mm-ddThh:mm:sssZ` format.'
          )
          .optional()
          .nullable(),
        name: z
          .string()
          .describe(
            'Policy name that is visible in the dashboard and checkout form.\n\nMin: 1 character  <br/>\nMax: 40 characters'
          )
          .min(1)
          .max(40)
          .optional(),
        body: z
          .string()
          .describe(
            'Policy body. Usually contains various terms and conditions.\n\nMin: 1 character\nMax: 50,000 characters\n\n<b>Note:</b> You can format text using various HTML tags such as `<p>`, `<b>`, `<ul>`, etc.'
          )
          .min(1)
          .max(50000)
          .optional(),
        eventId: z
          .string()
          .describe('ID of the event to which the policy belongs.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional(),
      })
    )
    .optional(),
});
export const GetPolicyRequest = z.object({
  policyId: z
    .string()
    .describe('Policy ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const GetPolicyResponse = z.object({
  _id: z
    .string()
    .describe('Policy ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the policy is updated.\n\nTo prevent conflicting changes, the current revision must be used when updating a policy.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe(
      'Date and time the policy was created in `yyyy-mm-ddThh:mm:sssZ` format.'
    )
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe(
      'Date and time the policy was updated in `yyyy-mm-ddThh:mm:sssZ` format.'
    )
    .optional()
    .nullable(),
  name: z
    .string()
    .describe(
      'Policy name that is visible in the dashboard and checkout form.\n\nMin: 1 character  <br/>\nMax: 40 characters'
    )
    .min(1)
    .max(40)
    .optional(),
  body: z
    .string()
    .describe(
      'Policy body. Usually contains various terms and conditions.\n\nMin: 1 character\nMax: 50,000 characters\n\n<b>Note:</b> You can format text using various HTML tags such as `<p>`, `<b>`, `<ul>`, etc.'
    )
    .min(1)
    .max(50000)
    .optional(),
  eventId: z
    .string()
    .describe('ID of the event to which the policy belongs.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional(),
});
